import { Title, Breadcrumbs } from "../../components";
import { useState, useEffect } from "react";
import api from "../../api";
import styles from "./style.module.css";
import { BsFiletypePdf, BsFiletypeDocx } from "react-icons/bs";
import { IoDocumentOutline } from "react-icons/io5";

const Documents = () => {
    const [documents, setDocuments] = useState([])
    useEffect(() => {
        api.getDocuments()
            .then((data) => {
                setDocuments(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);
    const getFileIcon = (file) => {
        const fileExtension = file.split('.').pop();
        switch (fileExtension) {
            case 'docx':
            case 'doc':
                return <BsFiletypeDocx />;
            case 'pdf':
                return <BsFiletypePdf />;
            default:
                return <IoDocumentOutline />;
        }
    }

    return (
        <>
            <Title title='Документы' />
            <Breadcrumbs urls={[{ title: 'Документы', path: '' }]} />
            <div className={styles.documents_content}>
                {documents.results?.map(document => {
                    return (
                        <a href={document.file} target="_blank" rel="noreferrer">
                            <div className={styles.document_content_single}>
                                <div className={styles.icon}>{getFileIcon(document.file)}</div>
                                <h1>{document.title}</h1>
                            </div>
                        </a>
                    )
                })}
            </div>
        </>
    );
}

export default Documents;